<template>
  <div
    class="d-flex mt-3 mb-2"
    :class="className"
  >
    <div 
      v-if="is3dRender" 
      class="custom-pagination-3d ml-auto mr-auto"
    >
      <b-button 
        :disabled="pagination.current_page < 2"
        variant="light"
        @click.prevent="changePage(pagination.current_page - 1)"
      >
        <i class="bi bi-chevron-left" />
      </b-button>
      <span class="ml-1">{{ pagination.current_page }}</span>
      <span> / </span>
      <span class="mr-1">{{ pagination.last_page }}</span>
      <b-button 
        :disabled="pagination.current_page >= pagination.last_page"
        variant="light"
        @click.prevent="changePage(Number(pagination.current_page) + 1)"
      >
        <i class="bi bi-chevron-right" />
      </b-button>
    </div>
    <ul 
      v-if="!is3dRender"
      class="pagination ml-auto mr-auto"
    >
      <li v-if="pagination.current_page > 1">
        <a
          href="javascript:void(0)"
          aria-label="First"
          @click.prevent="changePage(1)"
        >
          &laquo;
        </a>
      </li>
      <li v-if="pagination.current_page > 1">
        <a
          href="javascript:void(0)"
          aria-label="Previous"
          @click.prevent="changePage(pagination.current_page - 1)"
        >
          &lt;
        </a>
      </li>
      <template v-if="pagesNumber.length > 1">
        <li
          v-for="page in pagesNumber"
          :key="page"
          :class="{'active': page == pagination.current_page}"
        >
          <a
            href="javascript:void(0)"
            @click.prevent="changePage(page)"
          >{{ page }}</a>
        </li>
      </template>
      <li v-if="pagination.current_page < pagination.last_page">
        <a
          href="javascript:void(0)"
          aria-label="Next"
          @click.prevent="changePage(Number(pagination.current_page) + 1)"
        >
          >
        </a>
      </li>
      <li v-if="pagination.current_page < pagination.last_page">
        <a
          href="javascript:void(0)"
          aria-label="Last"
          @click.prevent="changePage(pagination.last_page)"
        >
          &raquo;
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
/* eslint vue/enforce-style-attribute: 0 */
  export default{
      props: {
      pagination: {
          type: Object,
          required: true
      },
      offset: {
          type: Number,
          default: 4
      },
      className: {
        type: String,
        default: ''
      },
      is3dRender: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      pagesNumber() {
        let from = this.pagination.current_page - this.offset;
        if (from < 1) {
          from = 1;
        }
        let to = from + (this.offset * 2);
        if (to >= this.pagination.last_page) {
          to = this.pagination.last_page;
        }
        let pagesArray = [];
        for (let page = from; page <= to; page++) {
          pagesArray.push(page);
        }
        return pagesArray;
      }
    },
    methods : {
      changePage(page) {
        this.$emit('update:pagination', {
          ...this.pagination,
          current_page: page,
        })
        this.$emit('paginate', page);
      }
    }
  }
</script>
<style>
.pagination {
  display: flex;
}

.pagination a {
  color: #007bff;
  float: left;
  padding: 6px 15px;
  text-decoration: none;
  transition: background-color .3s;
  border: 1px solid #ddd;
}

.pagination li.active a{
  background-color: #007bff;
  color: white;
  border: 1px solid #007bff;
}

.pagination li:first-child a {
    margin-left: 0;
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
}

.pagination li:last-child a {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
}
.pagination a:hover:not(.active) {background-color: #ddd;}

.hero-files-pagination .pagination {
  li.active a {
      background-color: #209C86 !important;
      color: white !important;
      border: 1px solid #209C86;
  }
    a {
    float: left;
    padding: 6px 15px;
    text-decoration: none;
    transition: background-color .3s;
    color: inherit !important;
    background-color: white !important;
  }
}
.custom-pagination-3d span {
  font-size: 0.75rem;
  line-height: 1rem;
  color: #64748b;
}
.custom-pagination-3d button {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  background-color: #fff !important;
  border: none !important;
  padding: 5px !important;
}
.custom-pagination-3d button:hover {
  background-color: #f1f5f9;
}
</style>
